
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("8gQF4"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("8gQF4", function(module, exports) {

let $6058aaccbf3a3578$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6058aaccbf3a3578$var$load("3VIZM"),
    $6058aaccbf3a3578$var$load("gyh6H"),
    $6058aaccbf3a3578$var$load("1F7LX"),
    $6058aaccbf3a3578$var$load("jZLnv"),
    $6058aaccbf3a3578$var$load("6edij"),
    $6058aaccbf3a3578$var$load("gknbb"),
    $6058aaccbf3a3578$var$load("6iz6l"),
    $6058aaccbf3a3578$var$load("4SCW2"),
    $6058aaccbf3a3578$var$load("36QeB"),
    $6058aaccbf3a3578$var$load("9q75n"),
    $6058aaccbf3a3578$var$load("iYHbd"),
    $6058aaccbf3a3578$var$load("cHb2G"),
    $6058aaccbf3a3578$var$load("2jJ1i"),
    $6058aaccbf3a3578$var$load("bd77Q"),
    $6058aaccbf3a3578$var$load("hnGEQ"),
    $6058aaccbf3a3578$var$load("3GuOt"),
    $6058aaccbf3a3578$var$load("jbM5v"),
    $6058aaccbf3a3578$var$load("dek7I"),
    $6058aaccbf3a3578$var$load("dYtBN"),
    $6058aaccbf3a3578$var$load("kNV5Y"),
    $6058aaccbf3a3578$var$load("6SWFK"),
    $6058aaccbf3a3578$var$load("9aQIt"),
    $6058aaccbf3a3578$var$load("5zapo"),
    $6058aaccbf3a3578$var$load("3MYQs"),
    $6058aaccbf3a3578$var$load("XZauT"),
    $6058aaccbf3a3578$var$load("4S1SF"),
    $6058aaccbf3a3578$var$load("jiFtb"),
    $6058aaccbf3a3578$var$load("lm9Lt"),
    $6058aaccbf3a3578$var$load("9atVd"),
    $6058aaccbf3a3578$var$load("9wPDc"),
    $6058aaccbf3a3578$var$load("1MWOL"),
    $6058aaccbf3a3578$var$load("6fQco"),
    $6058aaccbf3a3578$var$load("aOY32"),
    $6058aaccbf3a3578$var$load("7jSfd"),
    $6058aaccbf3a3578$var$load("4HZlX"),
    $6058aaccbf3a3578$var$load("kDqHr"),
    $6058aaccbf3a3578$var$load("6wr18"),
    $6058aaccbf3a3578$var$load("gT8XU"),
    $6058aaccbf3a3578$var$load("lE8tR"),
    $6058aaccbf3a3578$var$load("alA4m"),
    $6058aaccbf3a3578$var$load("ffEVr"),
    $6058aaccbf3a3578$var$load("7EorR"),
    $6058aaccbf3a3578$var$load("oTA4y"),
    $6058aaccbf3a3578$var$load("fPbCp"),
    $6058aaccbf3a3578$var$load("kuFG2"),
    $6058aaccbf3a3578$var$load("Wowvf"),
    $6058aaccbf3a3578$var$load("hhss7"),
    $6058aaccbf3a3578$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("fNUHF"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("fNUHF", function(module, exports) {

let $b8176ab7ca17432b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b8176ab7ca17432b$var$load("6wr18"),
    $b8176ab7ca17432b$var$load("cHb2G"),
    $b8176ab7ca17432b$var$load("lE8tR"),
    $b8176ab7ca17432b$var$load("alA4m"),
    $b8176ab7ca17432b$var$load("ffEVr"),
    $b8176ab7ca17432b$var$load("cX4Bp"),
    $b8176ab7ca17432b$var$load("dawn8"),
    $b8176ab7ca17432b$var$load("aQh37"),
    $b8176ab7ca17432b$var$load("bJVDE"),
    $b8176ab7ca17432b$var$load("oTA4y"),
    $b8176ab7ca17432b$var$load("fPbCp"),
    $b8176ab7ca17432b$var$load("kuFG2"),
    $b8176ab7ca17432b$var$load("1F7LX"),
    $b8176ab7ca17432b$var$load("3QXpo"),
    $b8176ab7ca17432b$var$load("hhss7"),
    $b8176ab7ca17432b$var$load("h3ABO"),
    $b8176ab7ca17432b$var$load("kC80R"),
    $b8176ab7ca17432b$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("dQ50r"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("dQ50r", function(module, exports) {

let $a13403c8e89763c7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a13403c8e89763c7$var$load("ez4I6"),
    $a13403c8e89763c7$var$load("aQMre"),
    $a13403c8e89763c7$var$load("b9CA3"),
    $a13403c8e89763c7$var$load("2YffH"),
    $a13403c8e89763c7$var$load("hzOXI"),
    $a13403c8e89763c7$var$load("hgIJE"),
    $a13403c8e89763c7$var$load("kkxT0"),
    $a13403c8e89763c7$var$load("xu7ej"),
    $a13403c8e89763c7$var$load("iQ4FP"),
    $a13403c8e89763c7$var$load("71gca"),
    $a13403c8e89763c7$var$load("jDHfX"),
    $a13403c8e89763c7$var$load("gdwbX"),
    $a13403c8e89763c7$var$load("82Jpo"),
    $a13403c8e89763c7$var$load("eXKRO"),
    $a13403c8e89763c7$var$load("im1VN"),
    $a13403c8e89763c7$var$load("d1Qyb"),
    $a13403c8e89763c7$var$load("czOM6"),
    $a13403c8e89763c7$var$load("cSTi7"),
    $a13403c8e89763c7$var$load("499Dr"),
    $a13403c8e89763c7$var$load("8pLtn"),
    $a13403c8e89763c7$var$load("8auEH"),
    $a13403c8e89763c7$var$load("jAeEl"),
    $a13403c8e89763c7$var$load("lKs3T"),
    $a13403c8e89763c7$var$load("9anPW"),
    $a13403c8e89763c7$var$load("3EXzu"),
    $a13403c8e89763c7$var$load("b2FtX"),
    $a13403c8e89763c7$var$load("gnDXu"),
    $a13403c8e89763c7$var$load("dl2qY"),
    $a13403c8e89763c7$var$load("kL5FA"),
    $a13403c8e89763c7$var$load("6iz6l"),
    $a13403c8e89763c7$var$load("4SCW2"),
    $a13403c8e89763c7$var$load("9q75n"),
    $a13403c8e89763c7$var$load("iYHbd"),
    $a13403c8e89763c7$var$load("2jJ1i"),
    $a13403c8e89763c7$var$load("bd77Q"),
    $a13403c8e89763c7$var$load("3VIZM"),
    $a13403c8e89763c7$var$load("gyh6H"),
    $a13403c8e89763c7$var$load("gBV5J"),
    $a13403c8e89763c7$var$load("djjX5"),
    $a13403c8e89763c7$var$load("c0JsV"),
    $a13403c8e89763c7$var$load("h3ABO"),
    $a13403c8e89763c7$var$load("iUEjf"),
    $a13403c8e89763c7$var$load("YAi2k"),
    $a13403c8e89763c7$var$load("adNrA"),
    $a13403c8e89763c7$var$load("oTA4y"),
    $a13403c8e89763c7$var$load("fPbCp"),
    $a13403c8e89763c7$var$load("6wr18"),
    $a13403c8e89763c7$var$load("kzjZo"),
    $a13403c8e89763c7$var$load("Wowvf"),
    $a13403c8e89763c7$var$load("cX4Bp"),
    $a13403c8e89763c7$var$load("dawn8"),
    $a13403c8e89763c7$var$load("ffEVr"),
    $a13403c8e89763c7$var$load("hhss7"),
    $a13403c8e89763c7$var$load("aQh37"),
    $a13403c8e89763c7$var$load("bJVDE"),
    $a13403c8e89763c7$var$load("1F7LX"),
    $a13403c8e89763c7$var$load("3QXpo"),
    $a13403c8e89763c7$var$load("jnVKv"),
    $a13403c8e89763c7$var$load("7EorR"),
    $a13403c8e89763c7$var$load("bgHzk"),
    $a13403c8e89763c7$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.40ea6ddc.js.map
